import { ApiIssuer } from "src/api/types";
import Radio from "src/components/form/Radio";
import { BANK_ICONS } from "src/lib/constants";

interface IdealPaymentMethodProps extends ApiIssuer {
	onClick: () => void;
	active: boolean;
	type: "circle" | "direct";
	variant: "dark" | "light";
}

const IdealPaymentMethod = ({
	onClick,
	name,
	icon,
	active,
	type,
	variant,
}: IdealPaymentMethodProps) => {
	return (
		<div
			{...{ onClick }}
			className={`flex items-center gap-4 group cursor-pointer hover:border-primary bg-${
				variant === "dark" ? "dark text-white" : "gray-900"
			} transition-all p-2 rounded-md border-2  border-${
				active
					? "dark-accent"
					: variant === "dark"
					? "dark-accent"
					: "gray"
			}`}
		>
			{type === "circle" && <Radio {...{ variant }} value={active} />}
			<div className="flex gap-4 items-center flex-1">
				{icon && (
					<img
						src={BANK_ICONS[icon] || BANK_ICONS["unknown"]}
						alt={icon}
						className="w-12"
					/>
				)}
				<span>{name}</span>
			</div>
			{type === "direct" && (
				<div className="w-12 flex items-center justify-center">
					<i className="fas fa-arrow-right"></i>
				</div>
			)}
		</div>
	);
};

IdealPaymentMethod.defaultProps = {
	type: "direct",
};

export default IdealPaymentMethod;
